import { environment } from '@upkey-platform/core/core-shared'

export const MY_RESUMES_API_URL = {
  resume: `${environment.apiUrl}/resumes`,
  getAllResumes: `${environment.apiUrl}/resumes/all`,
  generateResume: `${environment.apiUrl}/resumes/generate`,
  saveResume: `${environment.apiUrl}/resumes/save`,
  upload: `${environment.apiUrl}/resumes/upload`
}
